/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import AddButton from 'components/AddButton.jsx';
import ClassCardView from 'settings/components/ClassCardView.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Group from 'entities/Group';
import Legend from 'components/Legend.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import Text from 'components/Text.jsx';

import './styles/ClassCardSection.scss';

class ClassCardSection extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.instanceOf(Group)).isRequired,
    label: PropTypes.string.isRequired,
    addEnabled: PropTypes.bool,
    addModal: PropTypes.element,
    addText: PropTypes.string,
  };

  static defaultProps = {
    addEnabled: true,
    addText: 'Add class',
  };
  renderAddButton() {
    return this.props.addEnabled ? (
      <ModalTrigger modal={this.props.addModal}>
        <div className="ClassCardSection-addButton">
          <AddButton size="large" stack>
            <Text size="medium">{this.props.addText}</Text>
          </AddButton>
        </div>
      </ModalTrigger>
    ) : null;
  }

  render() {
    const cards = this.props.items.map(item => <ClassCardView key={item.id} group={item} />);
    return (
      <Fieldset>
        <Legend>{this.props.label}</Legend>
        <div className="ClassCardSection">
          {cards}
          {this.renderAddButton()}
        </div>
      </Fieldset>
    );
  }
}

export default ClassCardSection;
